import EvJourneyDashboard from '@modules/manifera-user/resources/js/pages/customer-app/ev-journey/dashboard'

export default function Dashboard() {
  return <EvJourneyDashboard />
}
